/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-07-03 12:45:02
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 16:56:37
 * @Content:
 */

import React, { useEffect, useState } from "react";
import { IAddressDatum } from "../../../../../service/activity/interface";
import styles from "./index.style";

const EDIT_ICON_URL =
  "https://s1.codooncdn.com/operation-tools/internal-user/2020-07-03T12.52.16/44x45x1136xGNlzSH7qT4RtJr7WSU.png";

interface IProps {
  address: IAddressDatum;
  onEdit: () => void;
  isEnd: boolean;
}

export const AddressCard: React.FC<IProps> = React.memo(
  ({ address, onEdit, isEnd }) => {
    return (
      <div style={styles.cardWrapper}>
        <div style={styles.addressWrapper}>
          <div style={styles.titleWrapper}>
            <div style={styles.userName}>{address.user_name}</div>
            <div style={styles.phoneNum}>{address.user_phone}</div>
          </div>
          <div style={styles.address}>
            {`${address.province_name}${address.city_name}${address.county_name}${address.address_detail}`}
          </div>
        </div>
        {isEnd ? null : (
          <div style={styles.editIconWrapper} onClick={onEdit}>
            <img style={styles.editIcon} src={EDIT_ICON_URL} />
          </div>
        )}
      </div>
    );
  }
);
